const trim = (v, max = 900) => {
  const s = String(v ?? "").trim();
  if (s.length <= max) return s;
  return `${s.slice(0, max)}…`;
};

const normalizeYesNo = (value) => {
  if (value === true || value === 1 || value === "1") return "evet";
  const v = String(value ?? "").toLocaleLowerCase("tr-TR").trim();
  if (v === "evet" || v === "yes") return "evet";
  if (v === "hayir" || v === "hayır" || v === "no") return "hayir";
  return null;
};

export const pickTlKaliteRowsForAi = (bundle) => {
  const tlItems = bundle?.tl_recordings?.items || [];
  const kaliteItems = bundle?.kalite_degerlendirme?.items || [];
  if (!tlItems.length || !kaliteItems.length) return null;

  const byDate = new Map(kaliteItems.map((r) => [String(r.report_date || "").slice(0, 10), r]));
  for (const tlRow of tlItems) {
    const key = String(tlRow.report_date || "").slice(0, 10);
    if (key && byDate.has(key)) {
      return { tlRow, kaliteRow: byDate.get(key), report_date: key };
    }
  }
  return { tlRow: tlItems[0], kaliteRow: kaliteItems[0], report_date: tlItems[0]?.report_date };
};

const CRITERIA = [
  { key: "ordeleme", label: "İrdeleme" },
  { key: "mr_isteme", label: "MR İsteme" },
  { key: "mr_tepinme", label: "MR Tepinme" },
  { key: "tedirginlik", label: "Tedirginlik" },
  { key: "uzmanlik", label: "Uzmanlık" },
];

/** API'ye gönderilecek kompakt bağlam */
export const buildSpecialAgentAiContext = (bundle, tlKaliteAlignment) => {
  if (!bundle) return null;

  const compare = pickTlKaliteRowsForAi(bundle);
  let tlKaliteCompare = null;
  if (compare) {
    const { tlRow, kaliteRow, report_date } = compare;
    tlKaliteCompare = {
      report_date,
      criteria: CRITERIA.map(({ key, label }) => {
        const tlVal = normalizeYesNo(tlRow[key]);
        const kVal = normalizeYesNo(kaliteRow[key]);
        return {
          label,
          tl: tlVal,
          kalite: kVal,
          match: tlVal != null && kVal != null && tlVal === kVal,
        };
      }),
      tl_text: {
        leader_report: trim(tlRow.leader_report),
        assistant_report: trim(tlRow.assistant_report),
      },
      kalite_text: {
        call1_evaluation: trim(kaliteRow.call1_evaluation),
        call2_evaluation: trim(kaliteRow.call2_evaluation),
        quality_user_name: trim(kaliteRow.quality_user_name, 80),
      },
    };
  }

  const mr = bundle.toplam_data_mr || {};
  const kaliteli = bundle.kaliteli_data_analiz?.row || null;
  const mola = bundle.mola_report?.summary || {};

  const modules = {
    mola: {
      working_days: mola.working_days ?? mola.active_days,
      avg_daily_talk: mola.avg_daily_talk_seconds,
      avg_daily_break: mola.avg_daily_break_seconds,
    },
    mr: {
      has_row: !!mr.has_agent_row,
      column_total: mr.column_total,
      ratios: (mr.ratio_metrics || []).map((r) => ({
        key: r.key,
        label: r.label,
        display: r.display,
        numerator: r.numerator,
      })),
      islem_orani: (mr.ratio_metrics || []).find((r) => r.key === "islem")?.display,
    },
    kaliteli: kaliteli
      ? {
          wp_conversion_rate: kaliteli.wp_conversion_rate,
          kaliteli_process_rate: kaliteli.kaliteli_process_rate,
          wp_processed_count: kaliteli.wp_processed_count,
          kaliteli_processed_count: kaliteli.kaliteli_processed_count,
        }
      : null,
    tl_yeni: (bundle.tl_yeni_asistan?.items?.[0]
      ? {
          report_date: bundle.tl_yeni_asistan.items[0].report_date,
          deficiencies_action: trim(bundle.tl_yeni_asistan.items[0].deficiencies_action, 500),
          decision_text: trim(bundle.tl_yeni_asistan.items[0].decision_text, 500),
        }
      : null),
  };

  return {
    company_id: bundle.company_id,
    agent: bundle.agent,
    start_date: bundle.start_date,
    end_date: bundle.end_date,
    tl_kalite_alignment: tlKaliteAlignment
      ? {
          percent: tlKaliteAlignment.percent,
          matched: tlKaliteAlignment.matched,
          compared: tlKaliteAlignment.compared,
          diffs: tlKaliteAlignment.diffs || [],
          message: trim(tlKaliteAlignment.message, 600),
        }
      : null,
    tl_kalite_compare: tlKaliteCompare,
    modules,
  };
};

export const specialAgentAiContextCacheKey = (ctx) => {
  if (!ctx) return "";
  try {
    return `sar-ai-v1-${ctx.start_date}-${ctx.end_date}-${ctx.agent?.id}-${ctx.tl_kalite_alignment?.percent ?? "x"}`;
  } catch {
    return "";
  }
};
